module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQ3NS45IDM3Ni43bC0xODguNyAyMTUuN0E0OCA0OCAwIDAgMCAzMjMuMyA2NzJoMzc3LjVhNDggNDggMCAwIDAgMzYuMS03OS42bC0xOTAtMjE3LjEtMS45LTEuOGE0OCA0OCAwIDAgMC02OS4xIDMuMnpNNTEyIDQzMi42TDY2NS41IDYwOGgtMzA3TDUxMiA0MzIuNnoiIGZpbGw9IiMwIiBwLWlkPSIxMDM4Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret up-outlined.svg
// module id = dtAB
// module chunks = 75